import { defineStore } from "pinia";
import { ref } from "vue";
import { i18n } from "~/plugins/vue-i18n";
import { useCustomizerStore } from "../customizer";


export const useGlobalStore = defineStore('global-store', () => {

    // -------------------------------------------------------------- Hot Key Manager --------------------------------------------------------------
    const hotKeyManager = ref<{
        isActive: boolean,
        duty: string,
        keyCombination: {
            ctrl: boolean,
            shift: boolean,
            alt: boolean,
            key: string
        },
        callback: () => void
    }[]>([
        {
            isActive: false,
            duty: 'goToNextLanguage',
            keyCombination: {
                ctrl: true,
                shift: true,
                alt: false,
                key: 'l'
            },
            callback: () => {
                setLanguage(selectedLanguage.value === 'fa' ? 'en' : 'fa')
            }
        }
    ])
    function addHotKey(duty: string, keyCombination: {
        ctrl: boolean,
        shift: boolean,
        alt: boolean,
        key: string
    }, callback: () => void) {
        hotKeyManager.value.push({
            isActive: false,
            duty,
            keyCombination,
            callback
        })
    }
    function activateHotKey(duty: string) {
        const hotKey = hotKeyManager.value.find(hk => hk.duty === duty)
        if (hotKey) {
            hotKey.isActive = true
        }
    }
    
    
    // -------------------------------------------------------------- language --------------------------------------------------------------
    const selectedLanguage = ref<'fa' | 'en'>('fa')
    function setLanguage(newLanguage: 'fa' | 'en') {
        selectedLanguage.value = newLanguage

        // update local storage and vue-i18n
        localStorage.setItem('userLanguage', newLanguage)
        i18n.global.locale.value = newLanguage

        const RTLLangList = ['fa']
        const isRTL = RTLLangList.includes(newLanguage)
        // @ts-ignore
        useCustomizerStore().setRTLLayout = isRTL
    }

    // -------------------------------------------------------------- user url trace --------------------------------------------------------------

    const user_trace = ref<string[]>([])

    function push_user_track(newTrack: string) {
        user_trace.value.push(newTrack)
    }
    function pop_user_track(): string | undefined {
        return user_trace.value.pop()
    }

    return {
        // ------------------- hot key manager
        hotKeyManager,
        addHotKey,
        activateHotKey,

        // ------------------- language
        selectedLanguage,
        setLanguage,

        // ------------------- user url trace
        user_trace,
        push_user_track,
        pop_user_track
    }
})